<template>
    <div>
        <Breadcrumbs main="Admin" submain="Portfolio" title="Teaching" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add Teaching</h7>
                            </button>
                        </div>
    
                        <div class="card-body">
                            <b-row>
                                <b-col xl="6">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
    
                                <b-col xl="6">
                                    <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
    
                            <div v-if="!loading && !error">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="teaching_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                        <template #cell(index)="data">
                                            {{ (currentPage - 1) * perPage + data.index + 1 }}
                                        </template>
    
                                        <template #cell(image)="row">
                                            <img :src="host + row.item.image" alt="" style="width: 120px; height: 80px;">
                                        </template>
    
                                        <template #cell(title)="row">
                                            <div v-if="row.item.title">
                                                <p>{{ row.item.title }}</p>
                                            </div>
                                        </template>
    
                                        <template #cell(source)="row">
                                            <div v-if="row.item.source">
                                                <p>{{ row.item.source }}</p>
                                            </div>
                                        </template>
    
                                        <!-- <template #cell(link)="row">
                                                    <div v-if="row.item.link">
                                                        <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                                    </div>
                                                    <div v-else>
                                                        N/A
                                                    </div>
                                                </template> -->
    
                                        <template #cell(action)="data">
                                            <span style="display: flex; gap: 12px;">
                                                <div>
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteTeaching(data.item.id)" title="Delete"></feather>
                                                </div>
                                                <div @click="editTeaching(data.item)">
                                                    <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </div>
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
    
                            <div v-else>
                                <loader />
                            </div>
    
                            <b-col md="6" class="my-1 p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    
        <!-- Teaching Create Modal -->
        <b-modal id="modal-prevent-closing" ref="modal" title="Add Teaching" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit()">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Level</label>
                            <input class="form-control" type="text" placeholder="Enter Level" v-model="teaching.level">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Year</label>
                            <input class="form-control" type="text" placeholder="Enter Year" v-model="teaching.year">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Course</label>
                            <input class="form-control" type="text" placeholder="Enter Course" v-model="teaching.course">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Teaching Edit Modal -->
        <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Teaching" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
            <form ref="form" @submit.stop.prevent="handleEditSubmit">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Level</label>
                            <input class="form-control" type="text" placeholder="Enter Level" v-model="edit_teaching.level">
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Year</label>
                            <input class="form-control" type="text" placeholder="Enter Year" v-model="edit_teaching.year">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>Course</label>
                            <input class="form-control" type="text" placeholder="Enter Course" v-model="edit_teaching.course">
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    
        <!-- Gallery Delete Modal -->
        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this teaching?</div>
        </b-modal>
    </div>
    </template>
    
        
    <script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import Datepicker from 'vuejs-datepicker';
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import moment from "moment";
    
    import {
        mapState
    } from 'vuex';
    import loader from '../loader/loader.vue';
    import {
        VueEditor
    } from "vue2-editor";
    
    export default {
        components: {
            Datepicker,
            loader,
            VueEditor
        },
    
        data() {
            return {
                editor: ClassicEditor,
    
                tablefields: [{
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'level',
                        label: 'Level',
                        sortable: true
                    },
                    {
                        key: 'year',
                        label: 'Year',
                        sortable: true
                    },
                    {
                        key: 'course',
                        label: 'Course',
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: 'Action',
                        sortable: false
                    }
                ],
    
              
    
                teaching: {
                   level:'',
                   year:'',
                   course:'',
                },
    
                edit_teaching: {
                    id: '',
                    level:'',
                    year:'',
                    course:'',
                },
    
                delete_value: null,
    
                filter: null,
                totalRows: 1,
                currentPage: 1,
                perPage: 10,
                pageOptions: [5, 10, 15]
            };
        },
    
        computed: {
            ...mapState({
                teaching_list: state => state.teaching.teaching,
                loading: state => state.teaching.teachingLoading,
                error: state => state.teaching.teachingError
            }),
    
            sortOptions() {
    
                return this.tablefields
                    .filter(f => f.sortable)
                    .map(f => {
                        return {
                            text: f.label,
                            value: f.key
                        };
                    });
            }
        },
    
        mounted() {
            this.$store.dispatch("teaching/fetchTeaching").then(() => {
                this.items = this.teaching_list
                this.totalRows = this.items.length;
            });
        },
    
        methods: {
    
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
    
            resetModal() {
                this.teaching.level = null
                this.teaching.year = null
                this.teaching.course = null
            },
    
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleSubmit()
            },
    
            handleSubmit() {
               
    
                this.$store.dispatch("teaching/addTeaching", {
                    teaching: this.teaching
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.teaching.level = null
                        this.teaching.year = null
                        this.teaching.course = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing')
                })
            },
    
            editTeaching(detail) {
                this.edit_teaching.id = detail.id ? detail.id : null
                this.edit_teaching.level = detail.level ? detail.level : null
                this.edit_teaching.year = detail.year ? detail.year : null
                this.edit_teaching.course = detail.course ? detail.course : null
               
    
            },
    
            resetEditModal() {
                this.edit_teaching.level = null
                this.edit_teaching.year = null
                this.edit_teaching.course = null
            },
    
            handleEditOk(bvModalEvent) {
                bvModalEvent.preventDefault()
                this.handleEditSubmit()
            },
    
            handleEditSubmit() {
               
                this.$store.dispatch("teaching/updateTeaching", {
                    id: this.edit_teaching.id,
                    teaching: this.edit_teaching,
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.edit_teaching.level = null
                        this.edit_teaching.year = null
                        this.edit_teaching.course = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-prevent-closing-edit')
                })
            },
    
            deleteTeaching(id) {
                this.delete_value = id
            },
    
            handleDeleteOk() {
                this.$store.dispatch("teaching/deleteTeaching", {
                    delete: this.delete_value
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_value = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
    </script>
    